import axios from "axios";

export const BACKEND_URL =
  (typeof window !== "undefined" && window.RUNTIME_CONFIG?.BACKEND_URL) ||
  process.env.REACT_APP_BACKEND_URL ||
  "";
const NORMALIZED_BACKEND_URL = BACKEND_URL.endsWith("/") ? BACKEND_URL.slice(0, -1) : BACKEND_URL;
export const API_BASE = NORMALIZED_BACKEND_URL ? `${NORMALIZED_BACKEND_URL}/api` : "/api";

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
